import React, { FC } from "react";
import { UserRowWrapper, RoleSelect, StatusBadge, DragHandle } from "components/Settings/Settings.styled";
import { User } from "types";
import { useDrag } from "react-dnd";
import { putSpecificUser } from "api/helpers";

interface UserRowProps {
  user: User;
  isCurrentUser?: boolean;
  teamId: string;
}

const UserRow: FC<UserRowProps> = ({ teamId, user, isCurrentUser }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "USER",
    item: { user, teamId },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    putSpecificUser(user.user_id, {"user_role": event.target.value});
  };

  return (
    <UserRowWrapper
      isCurrentUser={isCurrentUser}
      ref={drag}
      style={{ opacity: isDragging ? 0.5 : 1, cursor: isDragging ? "grabbing" : "default" }}
    >
      <div className="profile-icon">
        {user.profile_pic_url ? (
          <img src={user.profile_pic_url} />
        ) : (
          <h2>
            {user.first_name && user.first_name[0]}
            {user.last_name && user.last_name[0]}
          </h2>
        )}
      </div>
      <p className="name">
        {user.first_name} {user.last_name}
        {isCurrentUser && " ★"}
      </p>
      <RoleSelect>
        <select 
          value={user.user_role || "rep"} 
          onChange={handleChange}
          disabled={!isCurrentUser && user.user_role !== "admin"}
        >
          <option value="admin">Admin</option>
          <option value="rep">Rep</option>
        </select>
      </RoleSelect>
      <p className="email">{user.email}</p>
      <div className="active">
        <StatusBadge status={user.registered ? "Active" : "Invited"}>
          {user.registered ? "Active" : "Invited"}
        </StatusBadge>
      </div>
      <p className="team"></p>
      <DragHandle>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 10H16M8 14H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </DragHandle>
    </UserRowWrapper>
  );
};

export default UserRow;
